import { useEffect, useState } from 'react';
import api from '../api/axios';
import { Link } from 'react-router-dom';
import { MapPin, Home, Maximize2, Edit3, Search, SlidersHorizontal } from 'lucide-react';
import { useMemo } from 'react';
import ModalFiltros from '../components/ModalFiltros';
import { buildAssetUrl } from '../utils/api';

export default function VerPropiedades() {
  const [propiedades, setPropiedades] = useState([]);
  const [cargando, setCargando] = useState(true);
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const [filtros, setFiltros] = useState(null);
const [modalFiltrosAbierto, setModalFiltrosAbierto] = useState(false);
const propiedadesFiltradas = useMemo(() => {
  let resultado = [...propiedades];

  if (!filtros) return resultado;

  return resultado.filter(p => {
    const c = p.caracteristicas || {};

    // Tipo operación
    if (filtros.tipo_operacion && c.tipo_operacion !== filtros.tipo_operacion) {
      return false;
    }

    // Precio
    if (p.precio < filtros.precioMin || p.precio > filtros.precioMax) {
      return false;
    }

    // Zona
    if (
      filtros.zona &&
      p.zona?.toLowerCase() !== filtros.zona.toLowerCase()
    ) {
      return false;
    }

    // Recámaras
    if (filtros.recamaras) {
      const min = filtros.recamaras.includes('+')
        ? Number(filtros.recamaras.replace('+', ''))
        : Number(filtros.recamaras);

      if (Number(c.recamaras) < min) return false;
    }

    // Baños
    if (filtros.banos) {
      const min = filtros.banos.includes('+')
        ? Number(filtros.banos.replace('+', ''))
        : Number(filtros.banos);

      if (Number(c.banos) < min) return false;
    }

    // Amenidades
    for (const key in filtros.caracteristicas || {}) {
      if (filtros.caracteristicas[key] && !c[key]) {
        return false;
      }
    }

    return true;
  });
}, [propiedades, filtros]);


  useEffect(() => {
    api.get('/properties?zona=&precioMin=0&precioMax=99999999')
      .then(res => setPropiedades(res.data))
      .catch(err => console.error(err))
      .finally(() => setCargando(false));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header de la sección */}
      <div className="bg-slate-50 border-b border-slate-100 pt-12 pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          <span className="text-blue-600 text-xs font-bold uppercase tracking-[0.3em] mb-4 block">
            Catálogo Exclusivo
          </span>
          <h1 className="text-4xl md:text-5xl font-serif text-slate-900 mb-8">
            Propiedades <span className="italic">Disponibles</span>
          </h1>
          
          {/* Barra de "Filtros" (Visual) */}
          <div className="flex flex-wrap gap-4 items-center bg-white p-2 rounded-2xl shadow-sm border border-slate-100">
            <div className="flex-1 min-w-[200px] flex items-center px-4 gap-3 border-r border-slate-100">
              <Search size={18} className="text-slate-400" />
              <input 
                type="text" 
                placeholder="Buscar por zona o ciudad..." 
                className="w-full py-3 text-sm focus:outline-none"
              />
            </div>
<button
  onClick={() => setModalFiltrosAbierto(true)}
  className="flex items-center gap-2 px-6 py-3 text-sm font-bold uppercase tracking-widest text-slate-600 hover:bg-slate-50 rounded-xl transition-all"
>
  <SlidersHorizontal size={16} /> Filtros
</button>

          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        {cargando ? (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="w-10 h-10 border-2 border-slate-200 border-t-blue-600 animate-spin rounded-full mb-4"></div>
            <p className="text-slate-400 text-sm tracking-widest uppercase">Buscando residencias...</p>
          </div>
        ) : propiedadesFiltradas.length === 0 ? (
          <div className="text-center py-20 bg-slate-50 rounded-3xl border border-dashed border-slate-200">
            <Home size={40} className="mx-auto text-slate-300 mb-4" />
            <p className="text-slate-500 font-serif italic text-xl">No hemos encontrado propiedades que coincidan.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {propiedadesFiltradas.map(p => (
              <div key={p.id} className="group flex flex-col">
                {/* Imagen con Badge de precio */}
                <div className="relative overflow-hidden rounded-2xl aspect-[4/5] mb-6">
                  <Link to={`/propiedad/${p.id}`}>
                    <img 
                      src={buildAssetUrl(p.foto_principal)} 
                      alt={p.titulo} 
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </Link>
                  
                  {/* Botón de edición rápido si es dueño/admin */}
                  {(usuario?.rol === 'superadmin' || usuario?.id === p.asesor_id) && (
                    <Link
                      to={`/editar/${p.id}`}
                      className="absolute top-4 right-4 p-3 bg-white/90 backdrop-blur-md rounded-full text-slate-900 hover:bg-blue-600 hover:text-white transition-all shadow-xl"
                    >
                      <Edit3 size={16} />
                    </Link>
                  )}

                  <div className="absolute bottom-6 left-6">
                    <p className="text-white text-2xl font-light">
                      ${p.precio.toLocaleString()}
                    </p>
                  </div>
                </div>

                {/* Contenido de la tarjeta */}
                <div className="flex flex-col flex-1 space-y-3">
                  <div className="flex items-center gap-2 text-blue-600">
                    <MapPin size={14} />
                    <span className="text-[10px] font-bold uppercase tracking-widest">{p.ubicacion}</span>
                  </div>
                  
                  <Link to={`/propiedad/${p.id}`}>
                    <h2 className="text-xl font-serif text-slate-900 group-hover:text-blue-700 transition-colors leading-tight">
                      {p.titulo}
                    </h2>
                  </Link>

                  <div className="flex items-center gap-6 pt-2 text-slate-400">
                    <div className="flex items-center gap-1.5">
                      <Maximize2 size={16} />
                      <span className="text-xs font-medium">{p.caracteristicas?.area || '--'} m²</span>
                    </div>
                    <div className="h-4 w-[1px] bg-slate-100" />
                    <span className="text-[10px] uppercase font-bold tracking-tighter">Residencial</span>
                  </div>
                  
                  <Link 
                    to={`/propiedad/${p.id}`} 
                    className="pt-4 text-xs font-bold uppercase tracking-widest text-slate-900 group-hover:translate-x-2 transition-transform inline-flex items-center gap-2"
                  >
                    Ver Detalles <span>→</span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
{modalFiltrosAbierto && (
  <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-0 sm:p-6 transition-all">
    {/* Overlay con desenfoque */}
    <div
      className="absolute inset-0 bg-slate-900/60 backdrop-blur-md transition-opacity"
      onClick={() => setModalFiltrosAbierto(false)}
    />
    
    {/* Contenedor del Modal */}
    <div className="relative bg-white w-full max-w-lg h-[90vh] sm:h-auto sm:max-h-[85vh] rounded-t-[2.5rem] sm:rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden animate-in fade-in slide-in-from-bottom-10 duration-300">
      
      {/* Header del Modal */}
      <div className="flex items-center justify-between px-8 py-6 border-b border-slate-50">
        <div>
          <h3 className="text-xl font-serif text-slate-900">Filtros de búsqueda</h3>
          <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mt-1">Personaliza tu inversión</p>
        </div>
        <button 
          onClick={() => setModalFiltrosAbierto(false)}
          className="p-2 hover:bg-slate-100 rounded-full text-slate-400 hover:text-slate-900 transition-colors"
        >
          X
        </button>
      </div>

      {/* Cuerpo con Scroll */}
      <div className="flex-1 overflow-y-auto px-8 py-2 custom-scrollbar">
        <ModalFiltros
          filtrosIniciales={filtros}
          onAplicarFiltros={(f) => {
            setFiltros(f);
            setModalFiltrosAbierto(false);
          }}
        />
      </div>
    </div>
  </div>
)}

{/* Estilo para una scrollbar elegante */}
<style>{`
  .custom-scrollbar::-webkit-scrollbar {
    width: 4px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 10px;
  }
`}</style>
    </div>
    
  );


}
